import axiosInstance from './axiosInstance';

/**
 * Public APIs
 */

// Content (Blogs & News)
export const getAllContent = async (type, page = 1, limit = 12, search = '', sort = '', category = '', dateFilter = '') => {
    const response = await axiosInstance.get('/content', {
        params: { type, page, limit, search, sort, category, dateFilter }
    });
    return response.data;
};

export const getContentById = async (id) => {
    const response = await axiosInstance.get(`/content/${id}`);
    return response.data;
};

// Categories
export const getAllCategories = async (type) => {
    const response = await axiosInstance.get('/categories', {
        params: { type }
    });
    return response.data;
};

export const createCategory = async (categoryData) => {
    const response = await axiosInstance.post('/categories', categoryData);
    return response.data;
};

export const deleteCategory = async (id) => {
    const response = await axiosInstance.delete(`/categories/${id}`);
    return response.data;
};

// FAQs
export const getAllFAQs = async () => {
    const response = await axiosInstance.get('/faqs');
    return response.data;
};

// Logos
export const getAllLogos = async (status) => {
    const response = await axiosInstance.get('/logos', {
        params: { status }
    });
    return response.data;
};

// Settings
export const getSettings = async () => {
    const response = await axiosInstance.get('/settings');
    return response.data;
};

// Enquiries
export const submitEnquiry = async (enquiryData) => {
    const response = await axiosInstance.post('/enquiries', enquiryData);
    return response.data;
};

/**
 * Admin APIs
 */

// Auth
export const adminLogin = async (credentials) => {
    const response = await axiosInstance.post('/admin/login', credentials);
    return response.data;
};

// Admin Content Management
export const createContent = async (formData) => {
    const response = await axiosInstance.post('/content', formData);
    return response.data;
};

export const updateContent = async (id, formData) => {
    const response = await axiosInstance.put(`/content/${id}`, formData);
    return response.data;
};

export const deleteContent = async (id) => {
    const response = await axiosInstance.delete(`/content/${id}`);
    return response.data;
};

// Admin Enquiry Management
export const getAdminEnquiries = async (page = 1, limit = 10, search = '', sort = '', formType = '', dateFilter = '') => {
    const response = await axiosInstance.get('/enquiries', {
        params: { page, limit, search, sort, formType, dateFilter }
    });
    return response.data;
};

export const updateEnquiryStatus = async (id, status) => {
    const response = await axiosInstance.put(`/enquiries/${id}`, { status });
    return response.data;
};

export const deleteEnquiry = async (id) => {
    const response = await axiosInstance.delete(`/enquiries/${id}`);
    return response.data;
};

// Admin FAQ Management
export const createFAQ = async (faqData) => {
    const response = await axiosInstance.post('/faqs', faqData);
    return response.data;
};

export const updateFAQ = async (id, faqData) => {
    const response = await axiosInstance.put(`/faqs/${id}`, faqData);
    return response.data;
};

export const deleteFAQ = async (id) => {
    const response = await axiosInstance.delete(`/faqs/${id}`);
    return response.data;
};

// Admin Settings Management
export const updateSettings = async (settingsData) => {
    const response = await axiosInstance.put('/settings', settingsData);
    return response.data;
};

// Admin Logo Management
export const createLogo = async (formData) => {
    const response = await axiosInstance.post('/logos', formData);
    return response.data;
};

export const bulkCreateLogos = async (formData) => {
    const response = await axiosInstance.post('/logos/bulk', formData);
    return response.data;
};

export const updateLogo = async (id, formData) => {
    const response = await axiosInstance.put(`/logos/${id}`, formData);
    return response.data;
};

export const deleteLogo = async (id) => {
    const response = await axiosInstance.delete(`/logos/${id}`);
    return response.data;
};
